import { render, staticRenderFns } from "./message-image.vue?vue&type=template&id=f48bdda0&scoped=true"
import script from "./message-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-image.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-image.vue?vue&type=style&index=0&id=f48bdda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48bdda0",
  null
  
)

export default component.exports